import React, { useEffect, useState } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import chat100 from 'src/util/chat100';
import cookieUtil from 'src/util/cookieUtil';
import { ECookieName } from 'src/util/utilModel';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
import config from "src/config/config";

function ChatIcon(props: any) {
    const { app: { brandId }, theme } = props;
    const { config: { chat100SiteId, chat100IdAfterLogin, chat100IdBeforeLogin, showChat100Provider } } = theme;
    const token = cookieUtil.get(ECookieName.COOKIE_TOKEN);
    const isLoggedIn = !!token;
    let chat100CodePlanId = isLoggedIn ? chat100IdAfterLogin : chat100IdBeforeLogin;
    const [isChatOpen, setIsChatOpen] = useState(false);

    if (brandId === 31 || brandId === 47 || brandId === 39) {
        chat100CodePlanId = chat100IdAfterLogin;
    }

    const chat100Data = {
        siteId: chat100SiteId,
        codePlan: chat100CodePlanId
    };

    useEffect(() => {
        if (!showChat100Provider || !chat100SiteId || !chat100CodePlanId) return;

        const timer = setTimeout(async() => {
            try {
                await chat100.load(chat100Data);
            } catch (error: any) {
                console.error("Chat100 preload failed:", error);
            }
        }, 300);

        return () => clearTimeout(timer);
    }, [showChat100Provider, chat100SiteId, chat100CodePlanId]);

    const openChat = async () => {
        if (!showChat100Provider) return;

        try {
            await chat100.open(chat100Data);
        } catch (error: any) {
            console.error("Chat100 open failed:", error);
        }
    }

    const closeChat = async () => {
        if (!showChat100Provider) return;

        try {
            await chat100.close();
        } catch (error: any) {
            console.error("Chat100 close failed:", error);
        }
    }

    const chatHandle = () => {
        try {
            if (isChatOpen) {
                closeChat();
                setIsChatOpen(false);
            } else {
                openChat();
                setIsChatOpen(true);
            }
        } catch (error) {
            console.error("Chat toggle failed:", error);
        }
    }

    return (
        <ChatIconWrapper>
            <ChatIconBox onClick={chatHandle}>
                <LazyLoadImage
                    src={`${config.imageV3Host}/${theme.image.ChatSupportIcon}`}
                    alt="Gravatar"
                    effect="none"
                    height="100%"
                    width="100%"
                    placeholder={<PlaceholderImage />}
                />
            </ChatIconBox>
        </ChatIconWrapper>
    );
}

export default withTheme(withAppContext(ChatIcon));

const ChatIconWrapper = styled.div`
    display: block;
    height: 60px;
    width: 60px;
    max-height: 60px;
    bottom: 30px;
    left: 18px;
    position: fixed;
    border-radius: 50%;
    z-index: 2247483646 !important;
    cursor: pointer;
`;

const ChatIconBox = styled.div`
    height: 100%;
    width: 100%;
    border-radius: 60px;
    display: inline-block;
    overflow: hidden;
    text-align: center;
    position: relative;
    background-color: #fff;
    transform: scale(1);
    -webkit-transform: scale(1);

    img {
        height: 100%;
        width: 100%;
    }
`;